import React, { useEffect, useState } from 'react';
import MultipleOptions from './MultipleOptions';
import { returnSaneURL } from '../../../Utils/getImg';
import { TString } from '../Response/Utils';
import ModalPane from '../ModalPane/ModalPane';
import { loadStateSession } from '../../FlyfishComponents/flyfishutils/utils';
interface Props {
	data: any;
	handleSubmit: Function;
	botImageCheck: boolean;
	index: number;
	logoImagePath: string;
	shouldDisableActions: boolean;
	voiceResponse: boolean;
	timeStamp?: string;
	channel?: string;
	addUserResponse?: Function;
	configData: any;
}

const MultipleChoice = (props: Props) => {
	let { data, handleSubmit, voiceResponse, addUserResponse, configData } =
		props;
	const [optionsPopup, setOptionsPopup] = useState(false);
	const handleOpenPopup = (data) => {
		setOptionsPopup(true);
	};
	let options = data.lists.items;
	let highFrequencyOptions = options.filter(
		(eachOption) => eachOption.title.length > 20
	);
	useEffect(() => {
		const keyDownHandler = (event) => {
			if (event.key === 'Enter' && props.channel === 'whatsapp') {
				event.preventDefault();
				const userResponse = loadStateSession('userResp');
				let deliverQuicklinks = options.filter(
					(eachDisamb: any, index: number) => index === Number(userResponse) - 1
				);
				if (
					deliverQuicklinks &&
					deliverQuicklinks[0] &&
					!props.shouldDisableActions
				) {
					addUserResponse(userResponse.toString(), Date.now());
					handleSubmit(
						deliverQuicklinks[0].title.toString() ||
							deliverQuicklinks[0].displayText.toString(),
						{},
						{ isHidden: true }
					);
				}
			}
		};
		document.addEventListener('keydown', keyDownHandler);
		return () => {
			document.removeEventListener('keydown', keyDownHandler);
		};
	}, [options, !props.shouldDisableActions]);

	return (
		<div
			className='sf-multiple-w'
			tabIndex={voiceResponse || props.shouldDisableActions ? -1 : 0}
		>
			{props.botImageCheck && props.index == 0 ? (
				<div className={'preview-image-holder'}>
					<img
						src={returnSaneURL(props.logoImagePath)}
						alt={TString({ labelName: 'botAvatarLabel' })}
					/>
				</div>
			) : null}
			{props.channel === 'whatsapp' ? (
				options.length > 10 || highFrequencyOptions.length > 0 ? null : (
					<div
						className='sf-whatsapp-title-time'
						tabIndex={voiceResponse || props.shouldDisableActions ? -1 : 0}
					>
						<div
							className='sf-whatsapp-title body-text-1'
							dangerouslySetInnerHTML={{
								__html: data.displayResponse,
							}}
						/>
						<p className='whatsApp-time'>{props.timeStamp}</p>
					</div>
				)
			) : data.displayResponse.length > 0 &&
			  data.displayResponse !== 'carouselchoice' ? (
				<div
					tabIndex={voiceResponse || props.shouldDisableActions ? -1 : 0}
					className='sf-multiple-title body-text-1'
					dangerouslySetInnerHTML={{
						__html: data.displayResponse,
					}}
				/>
			) : null}
			{props.channel === 'whatsapp' &&
			(options.length > 3 || highFrequencyOptions.length > 0) ? (
				<div className='sf-whatsapp-quicklink-wrapper'>
					<div className='whatsapp-quicklink-disamb-wrapper'>
						<p
							className='whatsApp-text'
							dangerouslySetInnerHTML={{
								__html: data.displayResponse,
							}}
						/>
						{options.map((eachDisamb, index) => {
							return (
								<p className='whatsapp-quicklinks whatsApp-text' key={index}>
									{index + 1}. {eachDisamb.displayText || eachDisamb.actionText}
								</p>
							);
						})}
						{options && options.length > 0 && (
							<p className='quicklinks-footer whatsApp-text'>
								<span>Tip:</span> To select an option,can enter its option
								number. E.g. 1
							</p>
						)}
					</div>
					<p className='whatsApp-time' style={{ margin: '0' }}>
						{props.timeStamp}
					</p>
				</div>
			) : (
				// : props.channel === 'whatsapp' && ( options.length > 3 && highFrequencyOptions.length === 0 )
				// ? ( <div className='whatsapp-multi-options' onClick={()=>{handleOpenPopup(options)}}><p>More Options</p></div> )
				<div
					className={
						props.channel === 'whatsapp'
							? options.length <= 3 && options.length % 2 === 0
								? 'sf-double-whatsapp-multiple-result'
								: 'sf-single-whatsapp-multiple-result'
							: 'sf-multiple-result-w multi-result'
					}
				>
					{options.map((eachOption, index) => {
						return (
							<div
								key={index}
								style={
									props.shouldDisableActions
										? {
												cursor: 'not-allowed',
												width: props.channel === 'whatsapp' ? '100%' : '',
										  }
										: { width: props.channel === 'whatsapp' ? '100%' : '' }
								}
							>
								<MultipleOptions
									disable={props.shouldDisableActions}
									index={index}
									handleSubmit={handleSubmit}
									eachOption={eachOption}
									voiceResponse={voiceResponse}
									channel={props.channel}
									data={props.data}
									configData={configData}
								/>
							</div>
						);
					})}
				</div>
			)}
			{
				optionsPopup && (
					//  <ModalPane
					//     className='whatsapp-options'
					//     onClose={()=>setOptionsPopup(false)}
					//     heading={
					<div
						className='options-modal-container'
						//  style={{backgroundColor:'#fff',color:'#005d4b',display:'flex',flexDirection:'column',gap:'2px'}}
					>
						<div className='options-modal-header'>
							<p>cancel</p>
							<p className='whatsApp-text'>Options</p>
						</div>
						<div className='options-modal-title'>
							<p className='whatsApp-text'>Choose an Option</p>
						</div>
						<div className='options-modal-data'>
							{data.lists.items.map((eachOption, index) => {
								return (
									<div className='each-choice-option'>
										<p className='whatsApp-text'>{eachOption.title}</p>
										<div>Icon</div>
									</div>
								);
							})}
						</div>
						<div className='opitions-modal-footer'>Submit button</div>
					</div>
				)
				// }/>
			}
		</div>
	);
};
export default MultipleChoice;
